import {
  GET_ADDRESS_LIST,
  GET_ADDRESS_LIST_SUCCESS,
  GET_ADDRESS_LIST_ERROR
} from "../actions";

export const getAddressList = (contactId) => {
  return {
    type: GET_ADDRESS_LIST,
    payload: { contactId},
  };
};

export const getAddressListSuccess = (addressList) => ({
  type: GET_ADDRESS_LIST_SUCCESS,
  payload: addressList,
});

export const getAddressListError = (message) => ({
  type: GET_ADDRESS_LIST_ERROR,
  payload: { message },
});
